import { Link } from "react-router-dom";
import { User, LogIn, UserPlus } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export const AccountFloat = () => {
  const { user, isAdmin } = useAuth();

  if (user) {
    return (
      <Link
        to={isAdmin ? "/admin" : "/mi-cuenta"}
        data-testid="account-float"
        className="fixed bottom-24 left-6 z-40 group"
        aria-label="Mi cuenta"
      >
        <span className="relative flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full bg-gradient-to-br from-[#d4af37] to-[#b08a1f] text-black shadow-[0_8px_24px_rgba(212,175,55,0.45)] group-hover:scale-105 transition-transform">
          <User className="w-4 h-4" />
          <span className="text-xs uppercase tracking-widest font-semibold">
            {isAdmin ? "Admin" : (user.name?.split(" ")[0] || user.username)}
          </span>
        </span>
      </Link>
    );
  }

  // Guest: stacked login + register buttons (visible on all scroll positions)
  return (
    <div data-testid="guest-float" className="fixed bottom-24 left-6 z-40 flex flex-col gap-2 items-start">
      <Link
        to="/ingresar"
        data-testid="guest-login"
        className="flex items-center gap-1.5 pl-3 pr-4 py-2 rounded-full bg-gradient-to-br from-[#d4af37] to-[#b08a1f] text-black shadow-[0_6px_20px_rgba(212,175,55,0.5)] hover:scale-105 transition-transform text-[11px] uppercase tracking-widest font-bold"
      >
        <LogIn className="w-3.5 h-3.5" /> Iniciar sesión
      </Link>
      <Link
        to="/registro"
        data-testid="guest-register"
        className="flex items-center gap-1.5 pl-3 pr-4 py-2 rounded-full bg-black/70 backdrop-blur-sm border border-[#d4af37]/50 text-[#d4af37] shadow-[0_6px_20px_rgba(0,0,0,0.6)] hover:bg-[#d4af37]/10 hover:scale-105 transition-all text-[11px] uppercase tracking-widest font-bold"
      >
        <UserPlus className="w-3.5 h-3.5" /> Registrarme
      </Link>
    </div>
  );
};
